import { createContext } from "react";
import { IUser } from "../interfaces/IUser";

export const TokenContext = createContext("");

export interface IAccountContextProps {
  account?: IUser;
  setAccount: (account: IUser) => void;
}
export const AccountContext = createContext<IAccountContextProps>({
  account: undefined,
  setAccount: () => {},
});
